import { render, staticRenderFns } from "./PerkList.vue?vue&type=template&id=b80b89d8&"
import script from "./PerkList.vue?vue&type=script&lang=js&"
export * from "./PerkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports